import { Brain, FileText, PhoneOff, Shield } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";

const ITEMS = [
  {
    icon: FileText,
    title: "Mindre personlig data online",
    body: "Adress, telefonnummer och födelsedata tas bort från öppna kataloger och datamäklare.",
  },
  {
    icon: PhoneOff,
    title: "Färre attacker och störningar",
    body: "Spam, phishing och falska kontakter minskar när din information inte längre är lätt att hitta.",
  },
  {
    icon: Shield,
    title: "Lägre risk för ID-kapning",
    body: "När ditt digitala fotavtryck minskar blir identitetskapning betydligt svårare att genomföra.",
  },
  {
    icon: Brain,
    title: "Skydd i bakgrunden",
    body: "Din personliga information, identitet och ditt rykte skyddas kontinuerligt, utan att du behöver tänka på det.",
  },
];

export function Results() {
  return (
    <div className="space-y-10">
      <div className="space-y-4">
        <p className="font-bold text-3xl text-center tracking-tight">
          Resultatet när du använder Echorai
        </p>
        <p className="text-center text-muted-foreground max-w-2xl mx-auto">
          När din persondata tas bort från öppna register och datamäklare blir
          du svårare att hitta, och svårare att utnyttja.
        </p>
      </div>

      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {ITEMS.map(({ icon: Icon, title, body }) => (
          <Card
            key={title}
            className="border-cyan-300 dark:border-cyan-900 transition-all duration-200 hover:border-cyan-500 hover:shadow-lg"
          >
            <CardHeader>
              <div className="size-10 bg-cyan-500 rounded-xl flex justify-center items-center">
                <Icon className="text-white" />
              </div>
              <CardTitle>{title}</CardTitle>
            </CardHeader>
            <CardContent>
              <span className="text-muted-foreground text-sm">{body}</span>
            </CardContent>
          </Card>
        ))}
      </div>

      <p className="text-center text-muted-foreground">
        Echorai arbetar kontinuerligt i bakgrunden för att hålla din information
        borta från öppna källor.
      </p>
    </div>
  );
}
